import { Divider, Typography } from "antd"
import React, { useEffect } from "react"
import AddressModal from "./AddressModal"
import AddressTable from "./AddressTable"
import useAppDispatch from "hooks/useAppDispatch"
import { getAllEmployeeAddresses } from "store/Employee/address.slice"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"
import { useEmployeeScheduleDefaults } from "hooks/useScheduleDefaults"

const Addresses = () => {
	const dispatch = useAppDispatch()
	useEmployeeScheduleDefaults()
	const { selectedEmployee = "" } = useSchedulesQueryParams()

	useEffect(() => {
		if (selectedEmployee) dispatch(getAllEmployeeAddresses(selectedEmployee))
	}, [selectedEmployee])

	return (
		<div>
			<div className="flex w-full items-center gap-x-2 p-2">
				<div className="w-full">
					<Divider orientation="left" plain>
						<Typography.Title level={5}>Address History</Typography.Title>
					</Divider>
				</div>
				<AddressModal />
			</div>
			<AddressTable />
		</div>
	)
}

export default Addresses
